<template>
  <div :style="style" class="contact-container">
    <div class="contact-title">
        <CktextComponent :rawHtml="contacts.title">    
        </CktextComponent>    
    </div>
    <div class="contact-subtitle">
        <CktextComponent :rawHtml="contacts.subtitle">    
        </CktextComponent>
    </div>
    <div v-for="contact in contacts.contacts" :key="contact">
        <div v-if="contact.type==CONTACT_TYPE_TEL" class="contact-item">
            <span class="iconfont icon-lianxifangshidianhua contact-icon"></span>
            <div class="contact-data">{{contact.data}}</div>
            <span class="navigation-text" @click="onCall(contact.data)">Dial</span>
        </div>
        <div v-if="contact.type==CONTACT_TYPE_EMAIL" class="contact-item">
            <span class="iconfont icon-email contact-icon"></span>
            <div class="contact-data">{{contact.data}}</div>
            <span class="navigation-text" @click="onEmail(contact.data)">Write</span>
            <!--<span class="navigation-text" v-clipboard:copy="contact.data" v-clipboard:success="onCopy">Write</span>-->
        </div>
        <div v-if="contact.type==CONTACT_TYPE_ADDRESS" class="contact-item">
            <span class="iconfont icon-dizhi contact-icon"></span>
            <div class="contact-data">{{contact.data.address}}</div>
            <span class="navigation-text" @click="onGo(contact.data.location)">Go</span>
        </div>
    </div>
  </div>
</template>

<script>
import CktextComponent from '../CkText.vue';

export default {
  name: 'ContactComponent',
  components: {
    CktextComponent
  },
  data(){
    return {
      style:'',
      CONTACT_TYPE_TEL:1,
      CONTACT_TYPE_EMAIL:2,
      CONTACT_TYPE_ADDRESS:3,
      contacts:{}
    }
  },
  props: {
    component: null
  },
  methods:{
    onCall(phonenumber){

      if(phonenumber&&phonenumber.length>0){

        const link = document.createElement("a");
      
        link.href = 'tel:'+phonenumber;
      
        document.body.appendChild(link);
      
        link.click();
      
        document.body.removeChild(link);

      }
      else
        this.$toast.add({severity:'error', summary: this.$common.TITLE, detail:this.$t('message.phone_number_required'), life: 3000});

    },
    onEmail(email){
      if(email&&email.length>0){

          window.location.href='mailto:'+email;

      }
      else
         this.$toast.add({severity:'error', summary: this.$common.TITLE, detail:this.$t('message.email_required'), life: 3000});
    },
    onCopy(){
      this.$toast.add({severity:'success', summary: this.$common.TITLE, detail:this.$t('message.email_copied'), life: 3000});
    },
    onGo(location){

      if(location&&location.length>0){

        window.location.href=location;

      }
      else
        this.$toast.add({severity:'error', summary: this.$common.TITLE, detail:this.$t('message.navigation_disabled'), life: 3000});

    }
  },
  created(){
    
    this.style=this.$common.generateStyle(this.component.data.style);

    this.contacts=this.component.data.data;

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.contact-container{
    box-shadow: 0 0.256rem 0.59733rem rgb(0 0 0 / 7%);
    background-color: #f6f7f8;
    border-radius: 0.34133rem;
}
.contact-container:last-child{
    margin-bottom: 0px;
}
.contact-item{
    margin-bottom: 8px;
    font-size: 14px;
    line-height: 1.5;
    color: rgba(0,0,0,.85);
    box-sizing: border-box;
    padding: 10px 10px;
    background: #fff;
    border-radius: 2px;
    position: relative;
    transition: all .3s;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border:1px solid rgba(0,0,0,0);
}
.navigation-text{
    font-size: 0.8rem;
    color: #576b95
};
.contact-icon{
    font-size: 1.5rem;
    color: #576b95
}
.contact-data{
    flex-grow: 1;
    color: #576b95;
    margin-left: 1rem;
    text-align: left;
}
</style>
